import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "creteNewRRequest" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Create "),
  /*#__PURE__*/_createElementVNode("span", null, "Authorization Request")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "formContent"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" wants to access your Reference account.")
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("This will allow "),
  /*#__PURE__*/_createElementVNode("strong", null, "Reference OAuth 2.0"),
  /*#__PURE__*/_createTextVNode(" to:")
], -1)
const _hoisted_7 = { class: "permission" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "view, create, edit, delete Reference functionalities", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Make sure that you trust Reference OAuth 2.0", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "You may be sharing sensitive info with this site or app. Find out how Reference OAuth2.0 will handle yourdata by reviewing its terms of service and privacy policies. You can always see or remove access in your Reference account.", -1)
const _hoisted_11 = { class: "footersec" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Authorize")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_14 = {
  key: 1,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h3", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.user.agency_name), 1),
            _hoisted_4
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("img", {
              src: 'https://ui-avatars.com/api/?background=57429d&name=' +_ctx.user.first_name +'&rounded=true&color=ffffff'
            }, null, 8, _hoisted_5),
            _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InfoCircleOutlined)
          ]),
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_button, {
              class: "add",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authorizeApp())),
              loading: _ctx.confirmLoading
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_a_button, {
              class: "cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelRequest()))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.pageLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}